import FontIcon from 'components/icons';
import Link from 'components/link/link';

import classNames from 'classnames';

type ItemsProps = {
  classes: string[],
  description: string,
  title: string,
  url: string,
};

type MenuPanelProps = {
  items: ItemsProps[];
  bottomItem?: ItemsProps;
  subTitle?: string;
};

export default function MenuPanel({items, bottomItem, subTitle}: MenuPanelProps) {
  return <div className="menu-panel-container">
    { subTitle && <h4>{subTitle}</h4> }
    <ul className={`sub-menu-group ${items.length > 4 ? 'two-column' : ''}`}>
      {items.map((item, i) => {
        const [icon] = item.classes; // the first class supplied is used for the icon
        const hasDescription = !!item.description;

        return (
          <li key={ i } className={ classNames('sub-menu-list-item', { 'sub-menu-list-item-short': !hasDescription }) }>
            <div className="sub-menu-item">
              <Link to={ item.url }>
                <h3><FontIcon icon={ icon } />{item.title}</h3>
              </Link>
              { hasDescription &&
                <div className="sub-menu-item-description">
                  <p className="is-hidden-mobile-nav">{item.description}</p>
                </div>
              }
            </div>
          </li>
        );
      })}
    </ul>
    { bottomItem &&
      <div className="sub-menu-link">
        <Link to={ bottomItem.url }><FontIcon icon={ bottomItem.classes[0] } />{bottomItem.title}</Link>
      </div>
    }
  </div>;
};